import createStoreWithContext from '@/utils/store/create-store-with-context'

import ProgramApis from '../../apis'

const { withStore, useStore: useProgram } = createStoreWithContext(
  (set, get, swrFields) => ({
    ...swrFields,
  }),
  (data, query) => ({
    key: `program-${query?.handle}`,
    initialData: data,
    fetcher: () => ProgramApis.get(query?.handle),
    condition: Boolean(query?.handle),
    storeKey: 'program',
  }),
)

export const withProgramStore = withStore

export default useProgram
